import { createLucideIcon } from "lucide-react";

export const ViewOff = createLucideIcon(
    "ViewOff",
    [
        [
            "path",
            {
                d: "M15 13.5L16.5 16",
                key: "xfp13x",
            },
        ],
        [
            "path",
            {
                d: "M2 13L4 11",
                key: "q8sl5r",
            },
        ],
        [
            "path",
            {
                d: "M20 11L22 13",
                key: "x68rh7",
            },
        ],
        [
            "path",
            {
                d: "M22 8C22 8 18 14 12 14C6 14 2 8 2 8",
                key: "1s3e2l",
            },
        ],
        [
            "path",
            {
                d: "M9 13.5L7.5 16",
                key: "14uflx",
            },
        ],
    ],
);
